import {NavLink} from "react-router-dom";
import styled from 'styled-components';

import DETAILS from "@constants/shopDetails";
import WebPaths from "@router/paths/web";

import MobileMenu from "./index";

const Ul = styled.ul`
    list-style: none;
    overflow-y: auto;
    font-size: 15px;
    display: flex;
    flex-flow: row nowrap;
    padding-right: 0;
    flex-flow: column nowrap;
    background-color: #ffffff;
    box-shadow: 0 5px 2px 3px rgba(107, 33, 48, 0.2);
    border: 1px solid rgba(107, 33, 48, 0.3);
    position: fixed;
    border-radius: 100px 0 0 0;
    transform: ${({open}) => open ? 'translateX(0)' : 'translateX(110%)'};
    top: 0;
    right: 0;
    height: 100vh;
    width: 336px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    z-index: 99998;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 350px) {
        width: 100% !important;
    }

    li {
        padding: 18px 10px;
        color: #000;
    }
`;

const RightNav = ({logo, toggle, open}) => {
    const {name} = DETAILS;

    return (
        <Ul open={open}>
            <div className="mb-2 text-center">
                <NavLink to={WebPaths.home}>
                    <img src={logo} alt="logo" width={100}/>
                </NavLink>

            </div>

            <MobileMenu toggleMenu={toggle}/>
        </Ul>
    )
}

export default RightNav;
